<template>
  <div>
    <div class="demo-inline-spacing">
      <b-form ref="form" @submit.prevent="repeateAgain">
        <b-row>
          <b-col cols="12"> </b-col>
          <b-col cols="12"> </b-col>

          <b-col cols="12">
            <b-row>
              <b-col cols="7">
                <h6 style="text-align: center">{{ $t("Property") }}</h6>
              </b-col>

              <b-col cols="2"> </b-col>
            </b-row>
          </b-col>

          <b-col cols="12">
            <component
              :is="scrollbarTag"
              ref="scroll"
              class="scroll-area--data-list-add-new-property-add"
              :settings="settings"
              :key="$vs.rtl"
            >
              <b-row
                v-for="(item, index) in items"
                :id="item.stockPropertyId"
                :key="item.stockPropertyId"
                ref="row"
              >
                <!-- Item Name -->
                <b-col cols="7" style="padding-right: 0">
                  <b-form-group label-for="cost">
                    <b-form-input
                      v-model="item.code"
                      style="font-size: inherit"
                      id="cost"
                      type="text"
                      @keyup.enter="addProperty(index)"
                      :placeholder="$t('Property')"
                      :disabled="item.disabled"
                    />
                  </b-form-group>
                </b-col>

                <!-- Quantity -->

                <b-col v-if="!isMobile()" style="padding-right: 0" cols="2" class="mb-50">
                  <b-row v-if="item.stockPropertyId == ''">
                    <b-col style="padding: 0">
                      <b-button
                        variant="outline-light"
                        size="sm"
                        v-on:click="addProperty(index)"
                      >
                        <Icon
                          color="#28c76f"
                          icon="ic:baseline-save-all"
                          width="20"
                          height="20"
                        />
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-row v-else>
                    <b-col style="padding: 0; max-width: max-content">
                      <b-button
                        variant="outline-light"
                        size="sm"
                        v-on:click="
                          isSidebarActiveProcess = true;
                          deletePropertyInd = index;
                        "
                      >
                        <Icon
                          color="#EA5455"
                          icon="ic:baseline-remove-circle"
                          width="20"
                          height="20"
                        />
                      </b-button>
                    </b-col>
                    <b-col style="padding: 0; max-width: max-content">
                      <b-button
                        variant="outline-light"
                        size="sm"
                        v-on:click="updateProperty(index)"
                      >
                        <Icon
                          color="#7367F0"
                          icon="material-symbols:select-check-box"
                          width="20"
                          height="20"
                        />
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col v-else style="padding-right: 0" cols="2" class="mb-50">
                  <b-row v-if="item.stockPropertyId == ''">
                    <b-col style="padding: 0">
                      <b-button
                        variant="outline-light"
                        size="sm"
                        v-on:click="addProperty(index)"
                      >
                        <Icon
                          color="#28c76f"
                          icon="ic:baseline-save-all"
                          width="20"
                          height="20"
                        />
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-row v-else>
                    <b-col style="padding: 0; max-width: max-content">
                      <b-button
                        variant="outline-light"
                        size="sm"
                        v-on:click="
                          isSidebarActiveProcess = true;
                          deletePropertyInd = index;
                        "
                      >
                        <Icon
                          color="#EA5455"
                          icon="ic:baseline-remove-circle"
                          width="18"
                          height="20"
                        />
                      </b-button>
                    </b-col>
                    <b-col style="padding: 0; max-width: max-content">
                      <b-button
                        variant="outline-light"
                        size="sm"
                        v-on:click="updateProperty(index)"
                      >
                        <Icon
                          color="#7367F0"
                          icon="material-symbols:select-check-box"
                          width="18"
                          height="20"
                        />
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
                <!-- Remove Button -->
                <b-col cols="12" style="height: 5px"> </b-col> </b-row
            ></component>
          </b-col>
        </b-row>

        <!-- Row Loop -->
      </b-form>
    </div>
    <vs-prompt
      :title="$t('Warning')"
      :acceptText="$t('Submit')"
      :cancelText="$t('Cancel')"
      @accept="deleteProperty"
      :active.sync="isSidebarActiveProcess"
      color="danger"
    >
      <div style="text-align: center" class="con-exemple-prompt">
        <span>
          <b-row style="margin-top: 15px">
            <b-col cols="12" align-self="center">
              <h6>{{ $t("DoConfirm") }}</h6>
            </b-col>
          </b-row>
        </span>
      </div>
    </vs-prompt>
  </div>
</template>
<script>
import { uuid } from "vue-uuid";
import { isMobile } from "mobile-device-detect";
import { Icon } from "@iconify/vue2";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
  props: {
    data: {
      default: () => {},
    },
  },
  data() {
    return {
      deletePropertyInd: null,
      isSidebarActiveProcess: false,
      isMobile: function () {
        return isMobile;
      },
      searchedValue: "",
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      items: [
        {
          id: 0,
          code: "",
          disabled: false,
          stockPropertyId: "",
        },
      ],
    };
  },
  components: {
    Icon,
    VuePerfectScrollbar,
  },
  watch: {
    data(val) { 
      if (val) this.getPropertyList();
      return val;
    },
  },
  methods: {
    deletePropertyFunc(data) {
      const vs = this.$vs;
      this.$store
        .dispatch("stock/deleteExpertizeShemaProperty", data.stockPropertyId)
        .then((response) => { 
          if (response.status == 200) {
            try {
              vs.notify({
                text: response.data.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
							this.getPropertyList();
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data[0].value.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },

    deleteProperty() {
      this.deletePropertyFunc(this.items[this.deletePropertyInd]);
    },
    getPropertyList() {
      this.items = [
        {
          id: 0,
          code: "",
          disabled: false,
          stockPropertyId: "",
        },
      ];
      this.$store
        .dispatch("stock/listExpertizeShemaProperty", this.data.CheckListShemaId)
        .then((response) => { 
          if (response.success == true) {
            try {
              let allPropertysData = JSON.parse(response.json); 
              allPropertysData.forEach((val, index) => {
								console.log(val)
                this.items.push({
                  id: index + 1,
                  code: val.PropertyName,
                  disabled: false,
                  stockPropertyId: val.CheckListShemaPropertyId,
                });
              });
            } catch (error) {
              console.log(error);
            }
          } else {
            console.log(response.data.message.toString());
          }
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    submitProperty(data) {
      var createdId = uuid.v4();
      const vs = this.$vs;
      const obj = {
        checkListShemaPropertyId:
          data.stockPropertyId != "" ? data.stockPropertyId : createdId,
        propertyName: data.code,
        checkListShemaId: this.data.CheckListShemaId,
        checkListShemaName: this.data.CheckListShemaName,
      };  
      if (data.stockPropertyId != "") {
        this.$store
          .dispatch("stock/updateExpertizeShemaProperty", obj)
          .then((response) => {
            if (response.status == 200) {
              vs.notify({
                text: response.data.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });

              this.getPropertyList();
            } else {
              vs.notify({
                text: response.data[0].value.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          })
          .catch((error) => {
            return new Promise((resolve, reject) => {
              resolve(false);
            });
          });
      } else {
        delete obj.id;
        this.$store
          .dispatch("stock/addExpertizeShemaProperty", obj)
          .then((response) => {
						console.log(response)

            if (response.success == true) {
              vs.notify({
                text: response.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
							this.getPropertyList();
            } else {
              vs.notify({
                text: response.data.message.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          })
          .catch((error) => {
            return new Promise((resolve, reject) => {
              resolve(false);
            });
          });
      }
    },
    addProperty(ind) {
      this.submitProperty(this.items[ind]);
    },
    updateProperty(ind) {
      this.submitProperty(this.items[ind]);
    },
    clearFields() {
      this.items = [
        {
          id: 0,
          code: "",
          disabled: false,
          stockPropertyId: "",
        },
      ];
    },
  },
  mounted() {
    this.getPropertyList();
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
};
</script>
<style lang="scss" scoped>
.scroll-area--data-list-add-new-property-add {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 230px);

  &:not(.ps) {
    overflow-y: auto;
  }

  padding: 0px 30px 30px;
}
.con-vs-dialog {
  z-index: 520055;
}
</style>
